/* eslint-disable object-curly-newline */
import {
  Notification,
} from 'element-ui';
export default {
  // eslint-disable-next-line no-empty-pattern
  displayNotification({ }, { title, message, type }) {
    Notification({
      title,
      message,
      type,
    });
  },
};
